<template>
  <div>
    <div class="main">
      <div class="title">
        {{ this.$data.title }}
        <div @click="back" class="back">
          <img src="icon/learnIcon/icon_liucheng_fanhui1.svg" alt="">
        </div>
      </div>


      <bannerModule3 ref="bannerModule3" :itemCount="99" type="HOME_BANNER_TOP"/>
      <div class="e_box">
        <div class="_start" @click="this.e_start">
          <i class="icon_start"></i>
          <div>{{ this.$data.start_mock[0].title }}</div>
        </div>
        <div class="_mock" @click="this.e_mock">
          <i clas="icon_mock"></i>
          <div>{{ this.$data.start_mock[1].title }}</div>
        </div>
      </div>
    </div>

    <div class="connect">

    </div>

    </div>


  </div>
</template>
<script>
// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
// import adTypeEnum from '@/components/ad/adTypeEnum';

// Ad module

import bannerModule3 from "../../components/ad/bannerModule3";
import adModule from '@comp/ad/oneImageAdModule';

// config
import appConfig from '../../appConfig';

// util
import appHelper from '@util/appHelper';
import BannerModule3 from "../../components/ad/bannerModule3";

const config = {
  apiConfig: {
    get: {
      url: '/portal/v4/user/center/wallet/getTotalRevenue'
    }
  }
}

export default {
  name: "examination",
  components: {BannerModule3},
  extends: shixunPagePart,
  comments: {
    bannerModule3
  },
  data() {
    return {
      title: '考试平台',
      apiConfig: config.apiConfig,
      enableDataItem: true,
      autoLoadDataItem: true,
      start_mock: [
        {
          title: "正式考试"
        },
        {
          title: "模拟考试"
        }
      ]
    }
  },
  methods: {
    back() {
      appHelper.back(this)
    },

    tipRule() {
      appHelper.showHint('暂未开放操作');
    },
    e_start(){
      console.log("start");
    },
    e_mock(){
      console.log("mock")
    }
  }
}
</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  padding: 0 4%;
  box-sizing: border-box;
  background: #fff;

  .e_box {
    margin-top: 50px;
    height: 200px;
    width: auto;
    display: flex;
    justify-content: center;
  }

  ._start {
    margin-right: auto;
    margin-left: 50px;

    i {
      height: 20px;
      width: 20px;
      display: inline-block;
      background-color: #00b3ca;
       }

    div {
      display: inline;

    }
  }

  ._start + div {
    margin-right: 50px;

    i {
      //display: inline;
      height: 20px;
      width: 20px;
      display: inline-block;
      background-color: #0C00FF;
    }

    div {
      display: inline;

    }
  }
}

.title {
  width: 100%;
  height: 44px;
  text-align: center;
  line-height: 44px;
  font-size: 20px;

  font-weight: 600;
  color: #333333;

  overflow: hidden;

}

.back {
  float: left;
  margin-top: 4px;
}


.wallet_card {
  width: 90%;
  // height: 207px;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 18px;
  margin-bottom: 64px;
  background: #fff;
  padding: 0 16px;
  box-sizing: border-box;
  padding-bottom: 22px;

}

.wallet_title {
  padding: 12px 0;

  font-size: 16px;

  font-weight: 600;
  color: #333333;


  border-bottom: 1px solid #F6F6F6;
}

.wallet_money {
  padding: 18px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #F6F6F6;

}

.pfn {

  font-size: 12px;

  font-weight: 400;
  color: #999999;

}

.pfnb {

  font-size: 18px;
  font-weight: bold;
  color: #333333;

}

.pfns {

  font-size: 8px;

  font-weight: 600;
  color: #333333;

}

.btn_padding {
  margin-top: 12px;
  padding: 4px 16px;
  display: block;
  border: 1px solid #FFA724;

  border-radius: 14px;
}

.money_parms {
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  padding-left: 16px;
}

.wallet_explain {
  width: 90%;
  max-height: 230px;
  margin: 0 auto;

  .explain_title {

    font-size: 14px;

    font-weight: 400;
    color: #333333;

  }

  .explain_mr {
    margin-top: 12px;
  }


}


</style>
